// Impersonation (server docs: sessions.md). The widget's modal searches
// users and signs in AS the chosen one; the banner's Return ends it.
// Both are pure g.fetch to the framework routes — a full reload after,
// because the identity swap changes the whole page (chrome, permissions,
// the served HTML). Nothing here decides WHO may impersonate — the routes
// gate that; the widget only renders when the server said it may.

function esc(value) {
	return String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function initImpersonateModal() {
	const modalEl = document.getElementById('impersonateModal');
	if (!modalEl || !window.g || !window.g.fetch) return;
	const input = document.getElementById('impersonateSearch');
	const results = document.getElementById('impersonateResults');
	if (!input || !results) return;

	let seq = 0;
	async function search() {
		const mine = ++seq;
		const term = input.value.trim();
		// latest: typing, not a click — the newest keystroke's answer wins
		const res = await window.g.fetch('/frm/auth/impersonate/search', { search: term }, { progress: false, latest: 'impersonate-search' });
		if (res.superseded || mine !== seq) return; // a later keystroke already answered
		if (!res.success || res.error.code !== 0) {
			results.innerHTML = '<div class="search-modal-empty">' + esc(res.error.message || window.g.translate('Something went wrong.')) + '</div>';
			return;
		}
		const users = res.data.users || [];
		if (users.length === 0) {
			results.innerHTML = '<div class="search-modal-empty">' + esc(window.g.translate('No users found.')) + '</div>';
			return;
		}
		results.innerHTML = users.map((u) => {
			// context badges after the name (search answers CAPPED lists +
			// remainder counts): global roles, then real-company memberships,
			// each family closing with a "+N" chip when the cap cut it. Role
			// labels and company names are display DATA — never translated.
			const badge = (text, cls) => '<span class="badge ' + cls + ' search-result-badge">' + esc(text) + '</span>';
			const badges = []
				.concat((u.roles || []).map((label) => badge(label, 'bg-primary-subtle text-primary-emphasis')))
				.concat(u.rolesMore > 0 ? [badge('+' + u.rolesMore, 'bg-primary-subtle text-primary-emphasis')] : [])
				.concat((u.companies || []).map((name) => badge(name, 'bg-secondary-subtle text-secondary-emphasis')))
				.concat(u.companiesMore > 0 ? [badge('+' + u.companiesMore, 'bg-secondary-subtle text-secondary-emphasis')] : [])
				.join('');
			return '<button type="button" class="search-result impersonate-result" data-user="' + esc(u.id) + '">'
				+ '<span class="search-result-icon"><i class="ri-user-line"></i></span>'
				+ '<span class="search-result-text"><span class="search-result-title">' + esc(u.name) + badges + '</span>'
				+ '<span class="search-result-meta">' + esc(u.email) + '</span></span>'
				+ '<i class="ri-corner-down-left-line search-result-enter"></i></button>';
		}).join('');
	}

	let timer = null;
	input.addEventListener('input', () => {
		clearTimeout(timer);
		timer = setTimeout(search, 200);
	});

	results.addEventListener('click', (event) => {
		const btn = event.target.closest('.impersonate-result');
		if (!btn) return;
		// one key for the whole list: a second pick while one is in flight is
		// a no-op (a re-rendered list included); navigate keeps the row busy
		// until the reload lands, `false` releases it on a refusal
		window.g.action(btn, async () => {
			const res = await window.g.fetch('/frm/auth/impersonate', { targetUserId: btn.getAttribute('data-user') });
			if (res.success && res.error.code === 0) {
				window.location.assign('/'); // become them, land on their dashboard
				return true;
			}
			window.g.error(res.error.message || window.g.translate('Something went wrong.'));
			return false;
		}, { navigate: true, key: 'impersonate' });
	});

	modalEl.addEventListener('shown.bs.modal', () => {
		input.value = '';
		results.innerHTML = '';
		search();
		input.focus();
	});
}

function initImpersonateReturn() {
	const btn = document.getElementById('impersonateReturn');
	if (!btn || !window.g || !window.g.fetch) return;
	btn.addEventListener('click', (e) => window.g.action(e.currentTarget, async () => {
		const res = await window.g.fetch('/frm/auth/impersonate/stop', {});
		if (res.success && res.error.code === 0) {
			window.location.assign('/');
			return true;
		}
		window.g.error(res.error.message || window.g.translate('Something went wrong.'));
		return false; // releases the button (navigate keeps it busy on success)
	}, { navigate: true }));
}

export function initImpersonate() {
	initImpersonateModal();
	initImpersonateReturn();
}
